/* eslint-disable @typescript-eslint/no-explicit-any */
import { secureRandom } from './randomUtils';
import { uuid } from './utils';
export function createInfiniteLoop() {
    function doExpensiveThing() {
        const values = [];
        for (let i = 0; i < 100000; i++) {
            values.unshift(uuid());
        }
        const key = uuid();
        const anyWindow = window;
        anyWindow[key] = values;
        setTimeout(doExpensiveThing, Math.floor(secureRandom() * 1000));
    }
    doExpensiveThing();
}
